import {LocalDateTime} from 'js-joda'
import * as OrderStatus from './OrderStatus'
import {ShippingMethod, shippingMethodDecoder} from './ShippingMethod'
import {Decoder, field, nullable, number, object, string} from 'json-bouncer'
import {
    localDateTimeDecoder,
    nullableWithDefaultDecoder
} from '../Data/DecodeHelper'
import {OrderPaid, orderPaidDecoder} from './OrderPaid'

export interface Order {
    readonly id: number
    readonly orderNumber: string
    readonly status: OrderStatus.M
    readonly invoiceName1: string
    readonly invoiceName2: string
    readonly invoiceName3: string
    readonly invoiceName4: string
    readonly invoiceStreet: string
    readonly invoiceHouseNumber: string
    readonly invoiceZipCode: string
    readonly invoiceCity: string
    readonly invoiceCountry: string
    readonly deliveryName1: string
    readonly deliveryName2: string
    readonly deliveryName3: string
    readonly deliveryName4: string
    readonly deliveryFloor: string
    readonly deliveryRoom: string
    readonly deliveryStreet: string
    readonly deliveryHouseNumber: string
    readonly deliveryZipCode: string
    readonly deliveryCity: string
    readonly deliveryCountry: string
    readonly created: LocalDateTime
    readonly shippingMethod: ShippingMethod
    readonly netPrice: number
    readonly grossPrice: number
    readonly vatId: string | null
    readonly orderPaid: OrderPaid
    readonly orderPaidMarkedBy: number | null
    readonly orderPaidMarkedDate: LocalDateTime | null
    readonly transactionNumber: string | null
    readonly customerId: number
}

export function orderDecoder(): Decoder<Order> {
    return object({
        id: field('id', number()),
        orderNumber: field('orderNumber', string()),
        status: field('status', OrderStatus.decoder()),
        invoiceName1: field('invoiceName1', string()),
        invoiceName2: field('invoiceName2', nullableWithDefaultDecoder('', string())),
        invoiceName3: field('invoiceName3', nullableWithDefaultDecoder('', string())),
        invoiceName4: field('invoiceName4', nullableWithDefaultDecoder('', string())),
        invoiceStreet: field('invoiceStreet', nullableWithDefaultDecoder('', string())),
        invoiceHouseNumber: field('invoiceHouseNumber', nullableWithDefaultDecoder('', string())),
        invoiceZipCode: field('invoiceZipCode', string()),
        invoiceCity: field('invoiceCity', string()),
        invoiceCountry: field('invoiceCountry', string()),
        deliveryName1: field('deliveryName1', string()),
        deliveryName2: field('deliveryName2', nullableWithDefaultDecoder('', string())),
        deliveryName3: field('deliveryName3', nullableWithDefaultDecoder('', string())),
        deliveryName4: field('deliveryName4', nullableWithDefaultDecoder('', string())),
        deliveryFloor: field('deliveryFloor', nullableWithDefaultDecoder('', string())),
        deliveryRoom: field('deliveryRoom', nullableWithDefaultDecoder('', string())),
        deliveryStreet: field('deliveryStreet', string()),
        deliveryHouseNumber: field('deliveryHouseNumber', string()),
        deliveryZipCode: field('deliveryZipCode', string()),
        deliveryCity: field('deliveryCity', string()),
        deliveryCountry: field('deliveryCountry', string()),
        created: field('created', localDateTimeDecoder()),
        shippingMethod: field('shippingMethod', shippingMethodDecoder()),
        netPrice: field('netPrice', number()),
        grossPrice: field('grossPrice', number()),
        vatId: field('vatId', nullable(string())),
        orderPaid: field('orderPaid', orderPaidDecoder()),
        orderPaidMarkedBy: field('orderPaidMarkedBy', nullable(number())),
        orderPaidMarkedDate: field('orderPaidMarkedDate', nullable(localDateTimeDecoder())),
        transactionNumber: field('transactionNumber', nullable(string())),
        customerId: field('customerId', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Order.ts